// extracted by mini-css-extract-plugin
export default {"container":"kZ-z","title":"lZ-z","link":"mZ-z"};